import React from 'react'
import "../Styles/splash.css"

function Splash() {
  return (
    <div className='splash-container'>
         <div id="fast-food-img">
      </div>
    </div>
  )
}

export default Splash